import { useNavigate } from 'react-router-dom';
import { Globe, Newspaper, Instagram, Building2 } from 'lucide-react';

/**
 * /marketing/ — índice general del bloque marketing.
 *
 * Hub con los canales de marketing. Hoy solo "Web" está plenamente
 * operativo; Blog/Instagram/Google Business son placeholders a la
 * espera de configuración externa (o de definir alcance, en el caso
 * del blog).
 */
export default function Marketing() {
  const nav = useNavigate();

  const canales = [
    {
      slug: 'blog',
      titulo: 'Blog',
      descripcion: 'Rendimiento de los artículos del blog público.',
      icon: Newspaper,
      activo: true,
      proximamente: true,
    },
    {
      slug: 'web',
      titulo: 'Web',
      descripcion: 'Leads, analytics, SEO, ads y email marketing de duettocatering.com.',
      icon: Globe,
      activo: true,
    },
    {
      slug: 'instagram',
      titulo: 'Instagram',
      descripcion: 'Insights del perfil @duettocatering (seguidores, alcance, engagement).',
      icon: Instagram,
      activo: true,
      proximamente: true,
    },
    {
      slug: 'google-business',
      titulo: 'Google Business',
      descripcion: 'Búsquedas, vistas en Maps, llamadas, reseñas y fotos del perfil.',
      icon: Building2,
      activo: true,
      proximamente: true,
    },
  ];

  return (
    <div className="p-6 max-w-[1400px] mx-auto">
      <h1 className="text-2xl font-bold text-duetto-primary mb-2">Marketing</h1>
      <p className="text-sm text-gray-500 mb-6">
        Centro de control de todas las acciones de marketing de Duetto Catering.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {canales.map((c) => (
          <button
            key={c.slug}
            onClick={() => c.activo && nav(`/marketing/${c.slug}`)}
            disabled={!c.activo}
            className={`relative text-left bg-white border rounded-lg p-6 transition-shadow ${
              c.activo ? 'hover:shadow-lg cursor-pointer' : 'opacity-50 cursor-not-allowed'
            }`}
          >
            {c.proximamente && (
              <span className="absolute top-3 right-3 text-[10px] uppercase tracking-wider text-amber-700 bg-amber-50 border border-amber-200 px-2 py-0.5 rounded">
                Próximamente
              </span>
            )}
            <c.icon className="w-8 h-8 text-duetto-primary mb-3" />
            <div className="font-semibold text-lg">{c.titulo}</div>
            <p className="text-sm text-gray-500 mt-1">{c.descripcion}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
